var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chooseShop"},[_c('div',[_c('h3',[_vm._v("กรุณาเลือกสาขาเข้าใช้งาน")]),_c('div',{staticClass:"option"},_vm._l((_vm.shops),function(s,index){return _c('div',{key:index,attrs:{"data-tag":"selectShop"},on:{"click":function($event){return _vm.setShop(s)}}},[_vm._v(" "+_vm._s(s.code)+" "+_vm._s(s.name)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }